import { useState } from "react";
import { LuChevronUp } from "react-icons/lu";
import { cn } from "../../lib/utils";

export function ExpandableSection({
   title,
   children,
   className = "",
   isExpanded = false,
   onToggle,
   ...props
}) {
   const [expanded, setExpanded] = useState(isExpanded);

   function handleToggle() {
      const newExpanded = !expanded;
      setExpanded(newExpanded);
      onToggle?.(newExpanded);
   }

   return (
      <div
         className={cn(
            "border border-gray-300 rounded-md p-4",
            props.className
         )}
      >
         <button
            type="button"
            className="w-full outline-none! active:scale-100! focus:*:text-(--primaryColor)! relative flex justify-between items-center cursor-pointer"
            onClick={handleToggle}
         >
            <h3 className="w-full muted-md bordered mt-4! mb-5!">
               {title}
            </h3>

            <span
               className={cn(
                  "absolute right-0 top-5.5 transition-transform duration-300 ease-in-out text-(--textColor)!",
                  expanded && "rotate-180"
               )}
            >
               <LuChevronUp size={20} />
            </span>
         </button>

         <div
            className={cn(
               "grid transition-[grid-template-rows,opacity] duration-300 ease-in-out",
               expanded
                  ? "grid-rows-[1fr] opacity-100"
                  : "grid-rows-[0fr] opacity-0"
            )}
         >
            <div
               className={cn(
                  "overflow-hidden transition-transform duration-300 ease-in-out",
                  expanded
                     ? "translate-y-0"
                     : "-translate-y-2",
                  "mt-4",
                  className
               )}
            >
               {children}
            </div>
         </div>
      </div>
   );
}
